import React, { useState, useEffect } from 'react'
import { classNames } from 'core/helpers/misc'

const columns = [
  { path: 'streetName', title: 'Nome da Rua' },
  { path: 'quantity', title: 'Quantidade', style: { textAlign: 'center' } },
  { path: 'free', title: 'Livres', style: { textAlign: 'center' } },
  { path: 'used', title: 'Usadas', style: { textAlign: 'center' } },
]

export const ParkingLotsList = ({ service }) => {
  const [fetching, setFetching] = useState(false)

  const [streets, setStreets] = useState()

  useEffect(() => {
    setFetching(true)
    service
      .get('street.parkinglots')
      .then(resp => setStreets(resp))
      .finally(setFetching(false))
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <div className="kt-portlet kt-portlet--mobile">
        <div className="kt-portlet__head kt-portlet__head--lg">
          <div className="kt-portlet__head-label">
            <span className="kt-portlet__head-icon">
              <i className="kt-font-brand fas fa-store" />
            </span>
            <h3 className="kt-portlet__head-title">Lista de Vagas</h3>
          </div>
        </div>

        {fetching ? (
          <div className="kt-portlet__body kt-pb-0 position-relative">
            <div className="row">
              <div className="loading">
                Carregando <i className="fas fa-spinner fa-pulse" />
              </div>
            </div>
          </div>
        ) : (
          <div className="kt-portlet__body kt-portlet__body--fit">
            <div className="list kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded">
              <table className="kt-datatable__table">
                <thead className="kt-datatable__head">
                  <tr className="kt-datatable__row">
                    {columns.map(col => (
                      <>
                        <th className="kt-datatable__cell" style={col.style}>
                          <span>{col.title}</span>
                        </th>
                      </>
                    ))}
                  </tr>
                </thead>
                <tbody className="kt-datatable__body">
                  {streets &&
                    streets.items.length &&
                    streets.items.map(street => (
                      <>
                        <tr className="kt-datatable__row">
                          {columns.map(col => (
                            <td className="kt-datatable__cell" style={col.style}>
                              <span>{street[col.path]}</span>
                            </td>
                          ))}
                        </tr>

                        {street.parkingLots && street.parkingLots.length ? (
                          <>
                            {street.parkingLots.map(parkingLot => (
                              <tr className="kt-datatable__row kt-street_row">
                                <td
                                  className={classNames('kt-datatable__cell kt-font-bold', {
                                    'kt-font-success': !parkingLot.used,
                                    'kt-font-danger': parkingLot.used,
                                  })}
                                >
                                  {parkingLot.name} ({parkingLot.used ? 'Em Uso' : 'Livre'})
                                </td>
                              </tr>
                            ))}
                          </>
                        ) : (
                          ''
                        )}
                      </>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </>
  )
}
